import React from 'react';
import { Card } from "react-bootstrap";
import face_Katalin_Varga from "../../assets/img/face_Katalin_Varga.png";
import ShowMoreText from "react-show-more-text";
import projVargaK_macro from "../../assets/img/projVargaK_macro.png";

const Katalin_Varga_macro = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projVargaK_macro} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_Katalin_Varga}
              /* this will be the text on the banner */
              alt="DEVELOPING MIXED FREQUENCY MACRO- FINANCIAL MODELS"
            />{" "}
            <p className="text7">Katalin Varga</p>
            <br />
            <p className="text8">
              Economic Advisor{" "}
            </p>
            <p className="text8">Central Bank of Hungary</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The research focuses on the development and analysis mixed frequency models, which are
            standard and often used statistical and econometric tools used to estimate and forecast time
            series data that have different sampling frequencies. As a main example one can mention GDP
            and inflation nowcasts and forecasts provided at central banks combining weekly, monthly and
            quarterly data. Key approaches include parametric models, often using state-space
            representations and Kalman filter, MIDAS regression with Almon lags, which involves regressing a
            low-frequency variable on high-frequency variables using a specific weighting scheme. The other
            main avenue of modelling is semi- parametric models like Bayesian vector autoregressive trees
            (BAVART), which are capable to use nonbalanced data sets. The third very powerful model type
            is quantile regressions, which may use data of mixed-frequencies. These models are crucial for
            nowcasting and forecasting economic variables by utilizing timely, high-frequency data to inform
            lower-frequency trends.
            <br />
            The main advantage of using mixed frequency models is minimizing loss of information,
            maximizing timeliness of our models. Economic policy and financial market analysis require up-
            to-date information. Mixed-frequency models allow policymakers to use readily available, high-
            frequency indicators (like surveys or financial spreads) to nowcast or forecast lower-frequency
            economic variables (like GDP) before their official release. These models are capable of uncover
            dynamic and structural relationships between variables, which would otherwise be hidden by
            temporal aggregation.
            <br />
            The major field of application is predicting current (nowcasting) or future (forecasting) values of
            low-frequency variables like GDP, house prices or inflation using a combination of high-frequency
            data. These models inform policy makers about the recent changes and help analyse monetary
            policy and financial markets by linking daily, high-frequency data to monthly or quarterly
            macroeconomic variables.
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Katalin_Varga_macro;